module.exports = __webpack_public_path__ + "media/nova.2f40f835.mp3";